export const projects = [
  {
    title: "React menu components",
    subtitle: "React Hooks",
    description:
      "This is a reusable component which can be used for ecommerce websites, recipes or other application which require similar struture",
    image: "./project-1.jpg",
    link: "https://menucomponent.netlify.app/",
  },
  {
    title: "Accordion",
    subtitle: "React",
    description:
      "An accordion, it is a reusable components which is used in all websites for displaying Faqs,minimizing content on the page",
    image: "./project-2.jpg",
    link: "https://accordioncompnt.netlify.app/",
  },
  {
    title: "Tick-Tac-Toe",
    subtitle: "React",
    description:
      "Are you bored? Then play tic tac toe as a multiplayer with the option to reverse your moves",
    image: "./project-3.jpg",
    link: "https://ticktakt0e.netlify.app/",
  },
  {
    title: "Typing master",
    subtitle: "React Hooks",
    description: "Simple app to test your typing speed",
    image: "./project-4.jpg",
    link: "https://typinggame980.netlify.app/",
  },
  {
    title: "Tour Booking",
    subtitle: "HTML and SASS",
    description:
      "Home Page design of a tour website with basic HTML and advanced CSS concepts and animations",
    image: "./project-5.jpg",
    link: "https://natoursbooking.netlify.app/",
  },
  {
    title: "Workout Tracker",
    subtitle: "Javascript",
    description:
      "Workout tracker with live location feature allowing to store workout information on local storage",
    image: "./project-6.jpg",
    link: "https://maptygeo.netlify.app/",
  },
  {
    title: "Portfolio",
    subtitle: "Javascript",
    description: "A simple profile page for tours",
    image: "./project-7.jpg",
    link: "https://tourbookings.netlify.app/",
  },
  {
    title: "Hotel page",
    subtitle: "Javascript",
    description: "A food recipe page design using html, css and javascipt",
    image: "./project-8.jpg",
    link: "https://omnifood980.netlify.app/",
  },
];

export const JSPROJECT = [
  {
    title: "Sketch Board",
    subtitle: "Javascript,Express,Socket.io",
    description:
      "This app allows you to connect with others and perform sketching collaborating with basic functionalites like drawing rough ideas, uploading image, writing sticky notes and basic undo and redo functionality. It uses socketio,javascript,some basic html and css to do realtime sketching which syncs the changes wherever the URL is getting accessed",
    image: "./project-9.png",
    link: "https://my-sketchboard-c46e58e3543d.herokuapp.com/",
  },
];

export const skills = [
  "Java",
  "DSA",
  "JavaScript",
  "SpringBoot",
  "React",
  "Node",
  "Styled Components",
  "Bootstrap",
  "Plsql",
  "Jenkins",
];
export const twitterIcon = [{ image: "./twitter.svg" }];



// WEBPACK FOOTER //
// ./src/data.js